import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Reports = Loadable(lazy(() => import('./reports')));
const OustandingCustomers = Loadable(lazy(() => import('./outstanding-customers')));
const PendingReports = Loadable(lazy(() => import('./pending-reports')));
const AllBookingsCreationDate = Loadable(lazy(() => import('./allBookingsCreationDate')));
const StripePayments = Loadable(lazy(() => import('./stripePayments')));

const ReportsRoutes = [
  { path: '/dashboard/reports', element: <Reports />, auth: authRoles.admin },
  { path: '/dashboard/outstanding-customers', element: <OustandingCustomers />, auth: authRoles.admin },
  { path: '/dashboard/pending-reports', element: <PendingReports />, auth: authRoles.admin },
  {
    path: '/dashboard/booking-creation-date',
    element: <AllBookingsCreationDate />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/stripe-payments',
    element: <StripePayments />,
    auth: authRoles.admin,
  },
];

export default ReportsRoutes;
